<template>
    <div class="HardwareNotFound CardReaderSubComponent">
        <v-alert
            class="HardwareNotFound-alert CardReaderSubComponent-alert"
            color="warning"
            variant="tonal"
        >
            <div
                class="CardReaderSubComponent-title"
                v-text="$t('card_reader:detect_reader:reader_not_recognized:message')"
            />
            <span
                class="CardReaderSubComponent-description"
                v-text="$t('card_reader:detect_reader:not_found:instructions:drivers_not_installed:message')"
            />
        </v-alert>
        <v-btn
            class="CardReaderSubComponent-button"
            color="primary"
            variant="flat"
            @click="goToDrivers"
        >
            {{ $t('card_reader:detect_reader:show_install_step_button_text') }}
        </v-btn>
    </div>
</template>

<script setup>
const emit = defineEmits(['goToDrivers'])

function goToDrivers () {
    emit('goToDrivers')
}
</script>

<style lang="scss" scoped>
@import 'globalScss';

.HardwareNotFound {
    &-alert {
        margin-top: $s2;
    }
}
</style>
